import React from 'react';
import './index.css';
import App from './App';
import BestOfProvider from './context/BestOf';
import MenuBestOfProvider from './context/MenuBestOf';

const BestOf = () => {
  return (
    <MenuBestOfProvider>
      <BestOfProvider>
        <App />
      </BestOfProvider>
    </MenuBestOfProvider>
  )
}

export default BestOf;